import $ from 'jquery'
import Login from "../widgets/login";

class LoginButton {
    constructor(element) {
        this._loginButton = element;
        this.bindEvents();
    }

    bindEvents() {
        const _this = this;
        $(this._loginButton).on('click', function (event) {
            _this.showLoginForm(event);
        });
    }

    showLoginForm(event) {
        $('[data-login-modal]').each(function () {
            const loginModal = new Login(this, true);
            loginModal.showLoginForm(event);
        });
    }
}

export default LoginButton;